import React, { useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import navigationStore from './../../stores/navigation';
import { Views } from './../../enums/enums';
import accountStore from '../../stores/account';

// import views
import NewTracks from './../views/NewTracks';
import Catalog from './../views/Catalog';
import Search from './../views/Search';
import Favorites from './../views/Favorites';
import BackgroundMusic from './../views/BackgroundMusic';
import Singers from './../views/Singers';
import PlayLists from './../views/PlayLists';
import Settings from './../views/Settings';
import Account from './../views/Account';
import Feedback from './../views/Feedback';
import ChangePassword from './../views/ChangePassword';
import ChangeUsername from './../views/ChangeUsername';
import BgPlayer from './../views/BgPlayer';
import BgPlaylists from './../views/BgPlaylists';
import BgSearch from './../views/BgSearch';
import BgStyles from './../views/BgStyles';
import Home from './../views/Home';
import SongbookQueue from '../views/SongbookQueue';

const viewComponentMap = {
  [Views.NewTracks]: NewTracks,
  [Views.Catalog]: Catalog,
  [Views.Search]: Search,
  [Views.Favorites]: Favorites,
  [Views.BackgroundMusic]: BackgroundMusic,
  [Views.Singers]: Singers,
  [Views.PlayLists]: PlayLists,
  [Views.Settings]: Settings,
  [Views.Account]: Account,
  [Views.Feedback]: Feedback,
  [Views.ChangePassword]: ChangePassword,
  [Views.ChangeUsername]: ChangeUsername,
  [Views.BackgroundMusicPlayer]: BgPlayer,
  [Views.BackgroundMusicPlaylists]: BgPlaylists,
  [Views.BackgroundMusicSearch]: BgSearch,
  [Views.BackgroundMusicStyles]: BgStyles,
  [Views.SongbookQueue]: SongbookQueue,
  [Views.Home]: Home,
};

function ContainerLeft() {
  const currentView = navigationStore((state) => state.currentView);

  const viewCache = useRef({});
  

  if (currentView !== Views.Account && currentView !== Views.Settings && !viewCache.current[currentView]) {
    const Component = viewComponentMap[currentView] || Home;
    viewCache.current[currentView] = <Component />;
  }

  return (
    <Grid item xs={5.5} className="muvika-container-left-grid">
      <div className="muvika-container-left-view">
        {Object.entries(viewCache.current).map(([key, component]) => (
          <div
            key={key}
            style={{ display: key === currentView ? 'block' : 'none' }}
          >
            {component}
          </div>
        ))}

        {currentView === Views.Account && (
          <div style={{ display: 'block' }}>
            <Account />
          </div>
        )}

        {currentView === Views.Settings && (
          <div style={{ display: 'block' }}>
            <Settings />
          </div>
        )}
      </div>
    </Grid>
  );
}



export default ContainerLeft;
